import { render, staticRenderFns } from "./coaches_dashboard.vue?vue&type=template&id=85c20074&scoped=true"
import script from "./coaches_dashboard.vue?vue&type=script&lang=js"
export * from "./coaches_dashboard.vue?vue&type=script&lang=js"
import style0 from "./coaches_dashboard.vue?vue&type=style&index=0&id=85c20074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c20074",
  null
  
)

export default component.exports